import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { Link, Prompt } from 'react-router-dom';
import { BASE_URL } from 'consts';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import moment from 'moment';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

import MaterialTable, { MTableToolbar } from 'material-table';
import ModalRoot from 'components/Modal/ModalRoot';

import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TextField from '@material-ui/core/TextField';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import DatePicker from 'react-datepicker';

import { Delete } from '@material-ui/icons';
import { MdAdd, MdRemoveRedEye, MdRemove } from 'react-icons/md';
import { FaFileImage, FaFutbol } from 'react-icons/fa';
import { TiFlash } from 'react-icons/ti';
import { IoIosImages } from 'react-icons/io';

import uuidv1 from 'uuid/v1';
import _ from 'lodash';

import {
  VerticalTimeline,
  VerticalTimelineElement,
} from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';

import { RenderIconButton } from '../../shared/components/GenericComponents';
import { getTemplateFriendlyType } from 'templates';
import { Preview } from 'routes/Dashboard/Template';
import DialogComponent from './DialogComponent';

import 'react-datepicker/dist/react-datepicker.css';
import '../styles/EventEditor.css';

const styles = theme => ({
  title: {
    ...theme.Typography,
    color: '#044591',
  },
  bottomContainer: {
    display: 'flex',
    marginTop: theme.spacing(2),
    justifyContent: 'flex-end',
  },
  formControlSelect: {
    width: '100%',
    marginTop: theme.spacing(),
    marginLeft: theme.spacing(),
    marginRight: theme.spacing(),
  },
  dateFilter: {
    width: '100%',
    height: '30px',
    padding: '10px 20px',
    fontFamily: 'Helvetica, sans-serif',
    fontWeight: '300',
    fontSize: '16px',
    border: '1px solid #aaa',
    borderRadius: '4px',
    margin: '5px 20px 5px 20px',
  },
  calendar: {
    zIndex: 20,
  },
});

export class EventEditor extends Component {
  constructor(props) {
    super(props);

    let e = null;

    if (props.location.state && props.location.state.event) {
      e = this.fillForm(props.location.state.event);
      props.fillEventForm(props.location.state.event._id, e);
    }

    if (!e) {
      const defaultForm = {
        name: '',
        welcome: '',
        leagueSelected: null,
        gameSelected: null,
        host: null,
        background: '',
        templates: [],
        isDemo: false,
        isMyVersusDemo: false,
        demoFlow: [],
        closeDate: null,
      };
      e = defaultForm;
    }

    this.state = {
      ...e,
      preview: null,
      dialogComponent: false,
      dialogElement: false,
      selectedBackground: e.background ? e.background : 'undefined',
      formEdited: false,
      welcomePlaceHolder: e.name ? 'Welcome to ' + e.name : 'Enter Welcome Message',
      lastSequence: e.demoFlow.length ? e.demoFlow[0].sequence + 1 : 1,
      sequence: e.demoFlow.length ? e.demoFlow[0].sequence + 1 : 1,
      imageSelected: -1,
      period: '',
      clock: { minutes: 0, seconds: 0 },
      homeScore: 0,
      awayScore: 0,
      textDescription: '',
      selectElement: 'text',
      gameStatus: 'scheduled',
      autoClose: e.closeDate ? true : false,
      closeDate: e.closeDate ? moment(e.closeDate).toDate() : null,
      gameSelected: e.gameSelected ? e.gameSelected : null,
      gameDate: this.getGameDate(e.gameSelected ? e.gameSelected : null), //game && game. ? moment(e.closeDate).toDate() : null,
    };
  }

  componentDidMount() {
    if (this.props.location.state.myVersusDemo) {
      this.setState({ isDemo: true });
      this.setState({ isMyVersusDemo: true });
    }

    if (this.props.gamesList) {
      this.setState({ gameDate: this.getGameDate(this.state.gameSelected) });
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let newState = { ...prevState };

    let newDate = null;

    for (let game of nextProps.gamesList) {
      if (game._id.toString() === newState.gameSelected) {
        newDate = moment(game.scheduled).toDate();
      }
    }

    if (newState.gameDate === null && newState.gameDate !== newDate) {
      newState.gameDate = newDate;
    }

    return newState;
  }

  fillForm = event => {
    if (!event) {
      return null;
    }

    const form = {
      name: event.name ? event.name : '',
      welcome: event.welcome ? event.welcome : '',
      host: event.host && event.host._id ? event.host._id : null,
      background: event.background ? event.background : '',
      templates: event.templates ? event.templates : [],
      leagueSelected: null,
      gameSelected: null,
      isDemo: event.isDemo ? event.isDemo : false,
      isMyVersusDemo: event.isMyVersusDemo ? event.isMyVersusDemo : false,
      demoFlow: event.demoFlow ? event.demoFlow : [],
      closeDate: event.closeDate ? event.closeDate : null,
    };

    if (event.game) {
      form.gameSelected = event.game.toString();
    }

    if (event.league) {
      form.leagueSelected = event.league.toString();
    }

    return form;
  };

  getGameDate = gameSelected => {
    const { gamesList } = this.props;
    for (let game of gamesList) {
      if (game._id.toString() === gameSelected) {
        return moment(game.scheduled).toDate();
      }
    }

    return null;
  };

  handleChange = (name, value) => {
    this.setState({ [name]: value, formEdited: true });
  };

  setClock = value => {
    if (value) {
      const time = value.split(':');
      const minutes = parseInt(_.get(time, 0, 0));
      const seconds = parseInt(_.get(time, 1, 0));
      this.setState({
        clock: {
          minutes: minutes,
          seconds: seconds,
        },
      });
    }
  };

  getHomePosition = () => {
    const { leaguesList } = this.props;
    let result = 'left';

    if (this.state.leagueSelected && leaguesList) {
      for (let league of leaguesList) {
        if (league._id.toString() === this.state.leagueSelected.toString()) {
          if (league.homePosition.toString() === 'right') {
            result = 'right';
            break;
          }
        }
      }
    }

    return result;
  };

  isSameDate = (todaysDate, gameDate) => {
    return moment(gameDate).format('DD MMM YYYY') ===
      moment(todaysDate).format('DD MMM YYYY')
      ? true
      : false;
  };

  checkAddedTemplate = templateId => {
    let auxTemp = this.state.templates;

    for (const temp of auxTemp) {
      if (templateId && temp._id.toString() === templateId.toString()) {
        return true;
      }
    }

    return false;
  };

  isEventGame = rowId => {
    let game = this.state.gameSelected;
    return game && rowId && game.toString() === rowId.toString() ? true : false;
  };

  handleTemplateList = template => {
    const templateId = template._id;
    let foundIt = false;
    let auxTemp = this.state.templates;

    for (var i = 0; i < auxTemp.length; i++) {
      if (auxTemp[i]._id.toString() === templateId.toString()) {
        auxTemp.splice(i, 1);
        foundIt = true;
      }
    }

    if (!foundIt) {
      auxTemp.push({ _id: templateId });
    }

    this.setState({ templates: auxTemp });
  };

  handleInteractionDemo = template => {
    this.setState({ interactionDemo: template });
  };

  removeElementDemoFlow(idx) {
    let auxTemp = this.state.demoFlow;
    if (idx >= 0 && auxTemp.length) {
      auxTemp.splice(idx, 1);
    }
    const nextSequence = auxTemp.length ? auxTemp[0].sequence + 1 : 1;

    this.setState({
      demoFlow: auxTemp,
      lastSequence: nextSequence,
    });
  }

  handleDemoFlowList = async () => {
    const _id = uuidv1();
    const selectElement = this.state.selectElement;

    const sequence = this.state.sequence ? this.state.sequence : this.state.lastSequence;

    const homeScore = parseInt(_.get(this.state, 'homeScore', 0));
    const awayScore = parseInt(_.get(this.state, 'awayScore', 0));
    const clock = {
      minutes: parseInt(_.get(this.state, 'clock.minutes', 0)),
      seconds: parseInt(_.get(this.state, 'clock.seconds', 0)),
    };
    let element = {
      gameUpdate: {
        home: { score: homeScore },
        away: { score: awayScore },
        period: this.state.period,
        clock,
        status: this.state.gameStatus,
      },
      sequence,
      _id,
    };

    if (selectElement === 'text') {
      element['body'] = { text: this.state.textDescription };
      element['type'] = 'text';
      element['title'] = this.state.textDescription;
    }

    if (selectElement === 'interaction') {
      const interactionDemo = this.state.interactionDemo;

      element['body'] = {
        logoUrl: interactionDemo.icon,
        expUrl: BASE_URL + '/interaction/' + interactionDemo.type,
        mode: 'live',
        templateId: interactionDemo._id,
        status: 'active',
      };
      element['type'] = 'triggerTemplate';
      element['title'] = interactionDemo.name;
    }

    if (selectElement === 'image' && this.state.imageElement) {
      const url = `https://${this.state.imageElement.container}.s3.amazonaws.com/${this.state.imageElement.blob}`;
      const image = this.state.imageElement._id;
      element['body'] = { imageUrl: url, image };
      element['type'] = 'image';
      element['title'] = 'image';
    }

    const nextSequence = sequence + 1;
    let auxTemp = this.state.demoFlow;
    auxTemp.unshift(element);

    this.setState({
      demoFlow: auxTemp,
      dialogElement: false,
      lastSequence: nextSequence,
      sequence: nextSequence,
    });
  };

  changeSelectedBackgroundState = image => () => {
    this.setState({ selectedBackground: image });
  };

  prepareSubmit = () => {
    const { createEvent, updateEvent, eventId } = this.props;
    const state = this.state;

    if (state.name) {
      const data = {
        name: state.name,
        welcome: state.welcome || state.welcomePlaceHolder,
        leagueId: state.leagueSelected || null,
        gameId: state.gameSelected || null,
        host: state.host || null,
        background: state.background || null,
        templates: state.templates || [],
        isDemo: !!state.isDemo,
        isMyVersusDemo: !!state.isMyVersusDemo,
        demoFlow: state.demoFlow || [],
        closeDate: state.closeDate ? moment(state.closeDate).toDate() : null,
      };

      this.setState({ formEdited: false });

      if (eventId) {
        updateEvent(data);
      } else {
        createEvent(data);
      }
    } else {
      this.props.updateErrorMessage('The event name is required.');
    }
  };

  renderInteractionPreview(auth) {
    const { preview } = this.state;
    const previewUrl =
      preview && auth && auth.user
        ? `${BASE_URL}/template/${preview.type}/preview/${preview.id}/${auth.user._id}`
        : null;

    return (
      <Preview
        open={Boolean(this.state.preview)}
        onClose={() => this.setState({ preview: null })}
        url={
          this.state.preview && this.state.preview.redirect
            ? this.state.preview.redirect
            : previewUrl
        }
      />
    );
  }

  renderSelect(list, disabled, value, ref, title) {
    const { classes, UpdateListLeaguesAndGame, eventId } = this.props;

    return (
      <FormControl className={classes.formControlSelect}>
        <InputLabel id="demo-simple-select-label">{title}</InputLabel>
        <Select
          id="demo-simple-select"
          disabled={disabled}
          value={value}
          onChange={event => {
            this.handleChange(ref, event.target.value);
            if (ref === 'leagueSelected') {
              this.handleChange('gameSelected', '');
              UpdateListLeaguesAndGame(event.target.value, eventId);
            }
          }}
        >
          <MenuItem value={null}>
            <em>None</em>
          </MenuItem>
          {ref === 'leagueSelected'
            ? list.map(row => (
                <MenuItem key={row._id} value={row._id}>
                  <div className="select">{row.name}</div>
                </MenuItem>
              ))
            : list.map(row => {
                if (
                  row._id.toString() === this.state.gameSelected ||
                  (this.state.gameDate &&
                    this.isSameDate(this.state.gameDate, row.scheduled))
                ) {
                  return (
                    <MenuItem key={row._id} value={row._id}>
                      <div className="select">
                        <span className="bold-text">
                          {this.getHomePosition() === 'right'
                            ? row.away + ' vs ' + row.home
                            : row.home + ' vs ' + row.away}
                        </span>
                        {' - ' + moment(row.scheduled).format('lll')}
                      </div>
                    </MenuItem>
                  );
                } else {
                  return '';
                }
              })}
        </Select>
      </FormControl>
    );
  }

  renderHostTable() {
    const { hostList, hostPageSize } = this.props;

    return (
      <MaterialTable
        elevation={0}
        xs={12}
        options={{
          pageSizeOptions: [5, 10, 20],
          pageSize: hostPageSize,
          toolbar: true,
          paging: true,
          emptyRowsWhenPaging: false,
          rowStyle: rowData => ({
            backgroundColor: rowData._id === this.state.host ? '#dfeff5' : '#FFF',
          }),
        }}
        columns={[
          {
            cellStyle: { padding: '4px 15px 4px 15px' },
            headerStyle: { padding: '4px 15px 4px 15px' },
            title: 'Name',
            field: 'fullname',
            customSort: (a, b) =>
              a.fullname.toLowerCase().localeCompare(b.fullname.toLowerCase()),
          },
          {
            cellStyle: { padding: '4px 15px 4px 15px' },
            headerStyle: { padding: '4px 15px 4px 15px' },
            title: 'Options',
            render: row => (
              <div>
                {row._id === this.state.host ? (
                  <RenderIconButton
                    clickEvent={() => this.handleChange('host', '')}
                    title={'Click to remove host'}
                    placement={'top'}
                    icon={<Delete />}
                    color={'primary'}
                  />
                ) : (
                  <RenderIconButton
                    clickEvent={() => this.handleChange('host', row._id)}
                    title={'Click to add host'}
                    placement={'top'}
                    icon={<MdAdd />}
                    color={'primary'}
                  />
                )}
              </div>
            ),
            sorting: false,
          },
        ]}
        data={hostList}
        title="Add Host"
        components={{
          Toolbar: props => (
            <div>
              <MTableToolbar style={{ float: 'right' }} {...props} />
            </div>
          ),
        }}
      />
    );
  }

  renderTemplatesTable() {
    const { templatesList, templatesPageSize } = this.props;
    const title = this.state.isDemo ? 'Select template' : 'Add templates';
    return (
      <MaterialTable
        elevation={0}
        xs={12}
        options={{
          pageSizeOptions: [5, 10, 20],
          pageSize: templatesPageSize,
          toolbar: true,
          paging: true,
          emptyRowsWhenPaging: false,
          rowStyle: rowData => ({
            backgroundColor:
              this.checkAddedTemplate(rowData._id) ||
              (this.state.isDemo &&
                this.state.interactionDemo &&
                this.state.interactionDemo._id === rowData._id)
                ? '#dfeff5'
                : '#FFF',
          }),
        }}
        columns={[
          {
            cellStyle: { padding: '4px 15px 4px 15px' },
            headerStyle: { padding: '4px 15px 4px 15px' },
            title: 'Name',
            field: 'name',
            customSort: (a, b) =>
              a.name.toLowerCase().localeCompare(b.name.toLowerCase()),
          },
          {
            cellStyle: { padding: '4px 15px 4px 15px' },
            headerStyle: { padding: '4px 15px 4px 15px' },
            title: 'Type',
            field: 'type',
            render: rowData => getTemplateFriendlyType(rowData.type),
          },
          {
            cellStyle: { padding: '4px 15px 4px 15px' },
            headerStyle: { padding: '4px 15px 4px 15px' },
            title: 'Created At',
            field: 'createdAt',
            render: rowData => <div>{moment(rowData.createdAt).format('ll')}</div>,
            type: 'date',
          },
          {
            cellStyle: { padding: '4px 15px 4px 15px' },
            headerStyle: { padding: '4px 15px 4px 15px' },
            title: 'Updated At',
            field: 'updatedAt',
            defaultSort: 'desc',
            render: rowData => <div>{moment(rowData.updatedAt).format('ll')}</div>,
            type: 'date',
          },
          {
            cellStyle: { padding: '4px 15px 4px 15px' },
            headerStyle: { padding: '4px 15px 4px 15px' },
            title: 'Options',
            render: row => {
              const action = this.state.isDemo
                ? this.handleInteractionDemo
                : this.handleTemplateList;

              return (
                <div>
                  {this.checkAddedTemplate(row._id) ? (
                    <RenderIconButton
                      clickEvent={() => action(row)}
                      title={'Click to remove Template'}
                      placement={'top'}
                      icon={<Delete />}
                      color={'primary'}
                    />
                  ) : (
                    <RenderIconButton
                      clickEvent={() => action(row)}
                      title={'Click to add Template'}
                      placement={'top'}
                      icon={<MdAdd />}
                      color={'primary'}
                    />
                  )}
                  <RenderIconButton
                    clickEvent={() => {
                      this.setState({
                        preview: { id: row._id, type: row.type },
                      });
                    }}
                    title={'Click to preview this Template'}
                    placement={'top'}
                    icon={<MdRemoveRedEye />}
                    color={'primary'}
                  />
                </div>
              );
            },
            sorting: false,
          },
        ]}
        data={templatesList}
        title={title}
        components={{
          Toolbar: props => (
            <div>
              <MTableToolbar style={{ float: 'right' }} {...props} />
            </div>
          ),
        }}
      />
    );
  }

  renderDemoFlow() {
    const game_status = ['scheduled', 'inprogress', 'final'];
    return (
      <Paper className="demoFlow">
        <VerticalTimeline>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            iconStyle={{ background: 'rgb(16, 204, 82)', color: '#fff' }}
            icon={<MdAdd />}
            iconOnClick={() => {
              this.handleChange('dialogElement', true);
            }}
          >
            <h4 className="vertical-timeline-element-subtitle">Add new event</h4>
          </VerticalTimelineElement>
          {this.state.demoFlow.map((element, idx) => {
            const sequence = element.sequence ? element.sequence + ' secs' : '';
            const scores =
              typeof element.gameUpdate.home.score !== 'undefined' &&
              typeof element.gameUpdate.away.score !== 'undefined'
                ? `Home ${element.gameUpdate.home.score} x ${element.gameUpdate.away.score} Away`
                : null;
            const minutes = ('0' + element.gameUpdate.clock.minutes).slice(-2);
            const seconds = ('0' + element.gameUpdate.clock.seconds).slice(-2);
            const time = element.gameUpdate.period
              ? `${element.gameUpdate.period} - ${minutes}:${seconds}`
              : null;

            let iconStyle = {
              background: 'rgb(33, 150, 243)',
              color: '#fff',
            };
            let icon = (
              <FaFutbol
                onMouseEnter={() => {
                  this.handleChange('elementDemoFlowHover', idx);
                }}
                onMouseLeave={() => {
                  this.handleChange('elementDemoFlowHover', -1);
                }}
              />
            );
            if (element.type === 'trigger' || element.type === 'triggerTemplate') {
              icon = (
                <TiFlash
                  onMouseEnter={() => {
                    this.handleChange('elementDemoFlowHover', idx);
                  }}
                  onMouseLeave={() => {
                    this.handleChange('elementDemoFlowHover', -1);
                  }}
                />
              );
              iconStyle = {
                background: '#ffa500',
                color: '#fff',
              };
            }
            if (element.type === 'image') {
              icon = (
                <IoIosImages
                  onMouseEnter={() => {
                    this.handleChange('elementDemoFlowHover', idx);
                  }}
                  onMouseLeave={() => {
                    this.handleChange('elementDemoFlowHover', -1);
                  }}
                />
              );
              iconStyle = {
                background: '#E94043',
                color: '#fff',
              };
            }

            if (this.state.elementDemoFlowHover === idx) {
              icon = (
                <MdRemove
                  onMouseLeave={() => {
                    this.handleChange('elementDemoFlowHover', -1);
                  }}
                />
              );
              iconStyle = {
                background: '#ff0000',
                color: '#fff',
              };
            }
            return (
              <VerticalTimelineElement
                className="vertical-timeline-element--demoFlow"
                date={sequence}
                iconStyle={iconStyle}
                icon={icon}
                key={element.sequence}
                iconOnClick={() => {
                  this.removeElementDemoFlow(idx);
                }}
              >
                {element.type === 'image' ? (
                  <Card className="bigCard">
                    <CardMedia
                      className="bigCardMedia"
                      style={{
                        background: `url(${element.body.imageUrl}) 100% 100% no-repeat`,
                        backgroundSize: 'contain',
                      }}
                      image={`url(${element.body.imageUrl})`}
                    />
                  </Card>
                ) : (
                  <h3 className="vertical-timeline-element-title">{element.title}</h3>
                )}

                <h5 className="vertical-timeline-element-subtitle">
                  {scores} - {element.gameUpdate.status}
                </h5>
                <p>{time}</p>
              </VerticalTimelineElement>
            );
          })}
        </VerticalTimeline>

        <Dialog
          onClose={() => this.handleChange('dialogElement', false)}
          aria-labelledby="simple-dialog-title"
          open={this.state.dialogElement}
          className=""
        >
          <DialogContent className="">
            <FormControl className="">
              <Select
                id="demo-simple-select"
                value={this.state.selectElement ? this.state.selectElement : ''}
                onChange={event => {
                  this.handleChange('selectElement', event.target.value);
                }}
              >
                <MenuItem value={'text'}>
                  <div className="select">Text</div>
                </MenuItem>
                <MenuItem value={'interaction'}>
                  <div className="select">Interaction</div>
                </MenuItem>
                <MenuItem value={'image'}>
                  <div className="select">Image</div>
                </MenuItem>
              </Select>
            </FormControl>

            <div className="containerElementInput">
              {this.state.selectElement && (
                <Grid container spacing={3} className="genericElementData">
                  <Grid container item xs={6} spacing={3}>
                    {/* <Grid item xs={6}>
                      <TextField
                        label="Period"
                        required
                        value={this.state.period}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        onChange={event => {
                          this.handleChange('period', event.target.value);
                        }}
                        InputProps={{
                          inputProps: { min: 0 },
                        }}
                      />
                    </Grid> */}
                    {/* <Grid item xs={6}>
                      <TextField
                        label="Clock"
                        name="clock"
                        placeholder="0:00"
                        inputProps={{ maxLength: 5 }}
                        value={`${this.state.clock.minutes}:${
                          this.state.clock.seconds
                        }`}
                        onChange={event => {
                          this.setClock(event.target.value);
                        }}
                        required
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid> */}
                    {/* <Grid item xs={6}>
                      <TextField
                        label="Home score"
                        type="number"
                        required
                        value={this.state.homeScore}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        onChange={event => {
                          this.handleChange('homeScore', event.target.value);
                        }}
                        InputProps={{
                          inputProps: { min: 0 },
                        }}
                      />
                    </Grid> */}
                    {/* <Grid item xs={6}>
                      <TextField
                        label="Away score"
                        type="number"
                        required
                        value={this.state.awayScore}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        onChange={event => {
                          this.handleChange('awayScore', event.target.value);
                        }}
                        InputProps={{
                          inputProps: { min: 0 },
                        }}
                      />
                    </Grid> */}
                  </Grid>
                  <Grid container item xs={12} spacing={3}>
                    <Grid item xs={12}>
                      <TextField
                        label="Sequence in secs"
                        type="number"
                        required
                        value={this.state.sequence}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        onChange={event => {
                          this.handleChange('sequence', parseInt(event.target.value));
                        }}
                        InputProps={{
                          inputProps: { min: this.state.lastSequence },
                        }}
                      />
                    </Grid>
                    {/* <Grid item xs={6}>
                      <InputLabel id="demo-simple-select-label">
                        Game status
                      </InputLabel>
                      <Select
                        id="demo-simple-select"
                        disabled={false}
                        value={this.state.gameStatus}
                        onChange={event => {
                          this.handleChange('gameStatus', event.target.value);
                        }}
                      >
                        {game_status.map((row, idx) => (
                          <MenuItem key={idx} value={row}>
                            <div className="select">{row}</div>
                          </MenuItem>
                        ))}
                      </Select>
                    </Grid> */}
                  </Grid>
                </Grid>
              )}
              {this.state.selectElement === 'text' && (
                <div>
                  <TextField
                    label="Description"
                    name="descripton"
                    placeholder="Description"
                    inputProps={{ maxLength: 100 }}
                    value={this.state.textDescription}
                    onChange={event => {
                      this.handleChange('textDescription', event.target.value);
                    }}
                    required
                    fullWidth
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </div>
              )}
              {this.state.selectElement === 'interaction' && (
                <div>{this.renderTemplatesTable()}</div>
              )}
              {this.state.selectElement === 'image' && (
                <div>{this.renderImageLibrary()}</div>
              )}
            </div>
          </DialogContent>

          <DialogActions>
            <Button
              onClick={() => this.handleChange('dialogElement', false)}
              color="primary"
            >
              Close
            </Button>
            <Button onClick={() => this.handleDemoFlowList()} color="primary">
              Create
            </Button>
          </DialogActions>
        </Dialog>
      </Paper>
    );
  }

  renderImageLibrary() {
    return (
      <Grid container className="imageLibrary">
        {this.props.imageList &&
          this.props.imageList.map((image, idx) => {
            return (
              <Card className="smallCard" key={image._id}>
                <CardMedia
                  className="smallCardMedia"
                  style={{
                    background: `url(https://${image.container}.s3.amazonaws.com/${image.blob}) 100% 100% no-repeat`,
                    backgroundSize: 'contain',
                    border:
                      this.state.imageSelected === idx
                        ? '1px solid #f74747'
                        : '1px solid #fff',
                  }}
                  image={`url(https://${image.container}.s3.amazonaws.com/${image.blob})`}
                  onClick={() => {
                    this.handleChange('imageSelected', idx);
                    this.handleChange('imageElement', image);
                  }}
                />
              </Card>
            );
          })}
      </Grid>
    );
  }

  render() {
    const {
      auth,
      classes,
      leaguesList,
      gamesList,
      datesWithGames,
      backgroundList,
      channelId,
      channelName,
      errorMessage,
      myVersusDemo,
      UpdateListGames,
      eventId,
    } = this.props;

    const title = myVersusDemo ? 'My Versus Demo editor' : 'Event Editor';
    return (
      <div>
        <Grid container spacing={3} className="root">
          {auth.user == null && <Redirect to="/login" />}

          <Prompt
            when={this.state.formEdited}
            message={location =>
              `You are leaving the page with unsaved fields. Are you sure you want to leave?`
            }
          />

          <Grid item xs={12}>
            <Typography className={classes.title} variant="h6">
              {title}
            </Typography>
          </Grid>

          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              className={classes.btnBack}
              variant="text"
              color="default"
              component={Link}
              to={{
                pathname: '/dashboard/channel/admin/events',
                state: {
                  channelId: channelId,
                  channelName: channelName,
                },
              }}
            >
              BACK
            </Button>
          </div>

          <Grid item xs={12}>
            <Paper className="root" elevation={0}>
              <Typography variant="h6">Event</Typography>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <TextField
                    {...(errorMessage !== ''
                      ? { error: true, helperText: `${errorMessage}` }
                      : {})}
                    id="standard-full-width"
                    label="Event Name"
                    name="name"
                    placeholder="Enter Event name"
                    inputProps={{ maxLength: 100 }}
                    value={this.state.name}
                    onChange={event => {
                      this.handleChange('name', event.target.value);

                      this.handleChange(
                        'welcomePlaceHolder',
                        event.target.value !== ''
                          ? 'Welcome to ' + event.target.value
                          : 'Enter Welcome Message'
                      );
                    }}
                    required
                    fullWidth
                    //helperText="Full width!"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    id="standard-full-width"
                    label="Welcome Message"
                    name="welcome"
                    placeholder={
                      this.state.name !== ''
                        ? this.state.welcomePlaceHolder
                        : 'Enter Welcome Message'
                    }
                    value={this.state.welcome}
                    onChange={event => {
                      this.handleChange('welcome', event.target.value);
                    }}
                    multiline
                    required
                    fullWidth
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={this.state.autoClose}
                        onChange={() => {
                          this.handleChange('autoClose', !this.state.autoClose);

                          if (!this.state.autoClose === false) {
                            this.handleChange('closeDate', null);
                          }
                        }}
                        name="checkedB"
                        color="primary"
                      />
                    }
                    label="Auto Close Event"
                  />

                  {this.state.autoClose ? (
                    <DatePicker
                      popperClassName={classes.calendar}
                      className={classes.dateFilter}
                      selected={this.state.closeDate}
                      onChange={date => {
                        this.handleChange('closeDate', date);
                      }}
                      minDate={new Date()}
                      showTimeSelect
                      placeholderText="Click to select a date"
                      dateFormat="MMMM d, yyyy h:mm aa"
                    />
                  ) : (
                    ''
                  )}
                </Grid>

                <Grid item xs={12}>
                  <Typography variant="h6">
                    <span style={{ marginRight: '20px' }}>Game Selection </span>
                    <div style={{ display: 'inline-block' }}>
                      <RenderIconButton
                        clickEvent={() => this.handleChange('dialogComponent', true)}
                        title={'Change chat Background'}
                        placement={'top'}
                        icon={<FaFileImage />}
                      />
                      {!this.props.location.state.myVersusDemo && (
                        <FormControlLabel
                          control={
                            <Switch
                              checked={this.state.isDemo}
                              onChange={() => {
                                this.handleChange('isDemo', !this.state.isDemo);
                                if (!this.state.isDemo) {
                                  this.handleChange('isMyVersusDemo', false);
                                }
                              }}
                              name="checkedB"
                              color="primary"
                            />
                          }
                          label="Demo event"
                        />
                      )}

                      <DialogComponent
                        dialogType={'background'}
                        elementsList={backgroundList}
                        title={'Change chat background'}
                        open={this.state.dialogComponent}
                        close={() => this.handleChange('dialogComponent', false)}
                        click={this.changeSelectedBackgroundState}
                        clickConfirm={() => {
                          this.handleChange('background', this.state.selectedBackground);
                          this.handleChange('dialogComponent', false);
                        }}
                        selectedElement={this.state.selectedBackground}
                        confirmBtn={'Apply Changes'}
                      />
                    </div>
                  </Typography>
                </Grid>
                {!this.state.isDemo ? (
                  <React.Fragment>
                    <Grid item xs={6}>
                      {this.renderSelect(
                        leaguesList,
                        false,
                        this.state.leagueSelected ? this.state.leagueSelected : '',
                        'leagueSelected',
                        'League'
                      )}
                    </Grid>

                    <Grid
                      item
                      xs={6}
                      style={
                        !this.state.leagueSelected
                          ? { display: 'none' }
                          : { display: 'flex', alignSelf: 'flex-end' }
                      }
                      className="cur-game-date"
                    >
                      <DatePicker
                        popperClassName={classes.calendar}
                        className={classes.dateFilter}
                        selected={this.state.gameDate}
                        onChange={date => {
                          this.handleChange('gameDate', date);
                          UpdateListGames(
                            this.state.leagueSelected,
                            eventId,
                            moment(date)
                          );
                        }}
                        highlightDates={datesWithGames}
                        placeholderText="This highlight two ranges with custom classes"
                        dateFormat="MMMM d, yyyy"
                      />
                    </Grid>

                    <Grid
                      item
                      xs={6}
                      style={
                        !this.state.gameDate
                          ? { display: 'none' }
                          : { display: 'flex', alignSelf: 'flex-end' }
                      }
                    >
                      {this.renderSelect(
                        gamesList,
                        !this.state.leagueSelected || this.state.leagueSelected === ''
                          ? true
                          : false,
                        this.state.gameSelected ? this.state.gameSelected : '',
                        'gameSelected',
                        'Game'
                      )}
                    </Grid>

                    <Grid item xs={8}>
                      {this.renderTemplatesTable()}
                    </Grid>
                    <Grid item xs={4}>
                      {this.renderHostTable()}
                    </Grid>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <Grid item xs={6}>
                      {this.renderSelect(
                        leaguesList,
                        false,
                        this.state.leagueSelected ? this.state.leagueSelected : '',
                        'leagueSelected',
                        'League'
                      )}
                    </Grid>

                    <Grid
                      item
                      xs={6}
                      style={
                        !this.state.leagueSelected
                          ? { display: 'none' }
                          : { display: 'flex', alignSelf: 'flex-end' }
                      }
                      className="cur-game-date"
                    >
                      <DatePicker
                        popperClassName={classes.calendar}
                        className={classes.dateFilter}
                        selected={this.state.gameDate}
                        onChange={date => {
                          this.handleChange('gameDate', date);
                          UpdateListGames(
                            this.state.leagueSelected,
                            eventId,
                            moment(date)
                          );
                        }}
                        highlightDates={datesWithGames}
                        placeholderText="This highlight two ranges with custom classes"
                        dateFormat="MMMM d, yyyy"
                      />
                    </Grid>

                    <Grid
                      item
                      xs={6}
                      style={
                        !this.state.gameDate
                          ? { display: 'none' }
                          : { display: 'flex', alignSelf: 'flex-end' }
                      }
                    >
                      {this.renderSelect(
                        gamesList,
                        !this.state.leagueSelected || this.state.leagueSelected === ''
                          ? true
                          : false,
                        this.state.gameSelected ? this.state.gameSelected : '',
                        'gameSelected',
                        'Game'
                      )}
                    </Grid>
                    <Grid item xs={12}>
                      {this.renderDemoFlow()}
                    </Grid>
                  </React.Fragment>
                )}
              </Grid>
              <div className={classes.bottomContainer}>
                <Button
                  variant="text"
                  color="default"
                  className={classes.button}
                  component={Link}
                  to={{
                    pathname: '/dashboard/channel/admin/events',
                    state: {
                      channelId: channelId,
                      channelName: channelName,
                    },
                  }}
                >
                  cancel
                </Button>
                <Button
                  type="submit"
                  variant="text"
                  color="primary"
                  onClick={() => {
                    this.prepareSubmit();
                  }}
                  className={classes.button}
                >
                  Save Event
                </Button>
              </div>
            </Paper>
          </Grid>
          <ModalRoot />
          {this.renderInteractionPreview(auth)}
        </Grid>
      </div>
    );
  }
}

export default withStyles(styles)(EventEditor);
